const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaProdutor: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MANEJO_RELATORIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'MANEJO_RELATORIO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'MANEJO_RELATORIO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'MANEJO_RELATORIO_PRODUTOR_SELECT_LISTADO':
			return {
				...state,
				listaProdutor: action.payload.data
			};

        default:
            return state;
    }
}
